"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layoutKit = require("@arvinxu/layout-kit");
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_layoutKit.Flexbox, {
    gap: 12
  }, /*#__PURE__*/_react.default.createElement(_layoutKit.Flexbox, {
    horizontal: true,
    gap: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Progress, {
    percent: 70,
    status: "exception",
    type: 'dashboard'
  }), /*#__PURE__*/_react.default.createElement(_antd.Progress, {
    percent: 80,
    status: "exception",
    type: 'circle'
  })), /*#__PURE__*/_react.default.createElement(_antd.Progress, {
    percent: 50,
    status: "exception"
  }));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorError'],
  key: 'danger'
};
var _default = exports.default = componentDemo;